<template>
<div class="brand-card" no-body>
  <div class="brand-card-header newport-dark" style="height:60px;">
    <div style="width:100%;float: left; height: 40px; margin-left: 10px;">
      <img src="/static/img/newport-sm.png" border="0" style="float:left; height:40px; margin-left:5px;">
      <br/>
      <div style="color: white;float: left;position: absolute;top: 0px;margin-left: 55px;">
        {{nextItem.lockAlias}}
        <br/>({{nextItem.lockName}})
      </div>
    </div>
  </div>
  <div class="brand-card-body" >
    <div>
      <div class="text-uppercase text-muted small" style="text-align: left; margin-left: 7px;font-size:10px;">
        <div v-if="nextItem.isAvailable">
          <span class="badge badge-success float-right"><i class="icon-lock-open"></i> Unassigned</span> <br/>
        </div>
        <div v-if="!nextItem.isAvailable">
          <span class="badge badge-danger float-right"><i class="icon-lock"></i> Assigned</span> <br/>
        </div>
        <strong style="padding-right: 1em;"><i class="fa fa-key" style="color:green;"></i></strong>: {{nextItem.countEkey}} <br/>
        <strong style="padding-right: 1em;"><i class="fa fa-calculator" style="color:green;"></i></strong>: {{nextItem.countPass}}<br/>
        <strong style="padding-right: 1em; color:green;"><i class="icon-plus"></i> </strong>: {{nextItem.countTotal}}<br/>
        <strong style="padding-right: 1em;"><i class="fa fa-battery-full" style="color:green;"></i></strong>: {{nextItem.electricQuantity}}%<br/>

        <div v-if="nextItem.locationId !== null && nextItem.locationId > 0">
          <strong style="padding-right: 1em;"><i class="icon-location-pin" style="color:green;"></i></strong>: {{nextItem.location.name}}<br/>
        </div>
        <strong v-if="nextItem.lockGroups && nextItem.lockGroups.length > 0" style="padding-right: 1em;"><i class="icon-layers" style="color:green;"></i> :</strong>
          <div v-for="lgm in nextItem.lockGroups" :key="lgm.id">
            <strong>-</strong> {{lgm.mappedLockGroup.name}}
          </div>
      </div>
    </div>
    <div>
      <b-button type="button" variant="primary" v-on:click="hubActivate('unlock', nextItem.id)" style="margin-bottom:  10px;">
        <i class="fa fa-unlock"></i> Unlock
      </b-button>
      <br/>
      <b-button type="button" variant="danger" v-on:click="hubActivate('lock',nextItem.id)" v-if="(nextItem.modelNum && !nextItem.modelNum.toLowerCase().startsWith('sn158')) || !nextItem.modelNum">
          <i class="fa fa-lock"></i> Lock
      </b-button>
      <br/>
      <!--menu dropdown-->
      <div>
        <b-dropdown id="ddown-left" text="Menu" class="m-md-2" variant="newport" >
          <b-dropdown-item v-on:click="listKey(nextItem.id)"><i class="fa fa-key"></i> eKeys</b-dropdown-item>
          <b-dropdown-item v-on:click="listPasscode(nextItem.id)"><i class="fa fa-calculator"></i> Passcodes</b-dropdown-item>
          <b-dropdown-item v-if="nextItem.locationId !== null" v-on:click="addToLockGroup(nextItem.id)"><i class="icon-layers"></i> Add Lockgroup</b-dropdown-item>
          <b-dropdown-item v-if="nextItem.userId == onlineUserId" v-on:click="openHistory(nextItem.id)"><i class="fa fa-history"></i> Log History</b-dropdown-item>
          <b-dropdown-item v-if="nextItem.locationId === null" v-on:click="addToLocation(nextItem.id)"><i class="icon-location-pin"></i> Add to location</b-dropdown-item>
          <b-dropdown-item v-if="nextItem.userId == onlineUserId && ouht == 1" v-on:click="transferLocation(nextItem.id)"><i class="icon-location-pin"></i> Transfer</b-dropdown-item>
          <b-dropdown-item v-if="nextItem.userId == onlineUserId && ouht == 1" v-on:click="addLockToManager(nextItem.id)"><i class="icon-people"></i> Add Manager </b-dropdown-item>
          <b-dropdown-item v-if="nextItem.userId == onlineUserId " v-on:click="detailLock(nextItem.id)"><i class="icon-list"></i> All Details</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</div>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_HUB_SEND = BASE + '/api/hubs/send'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'access_token': data.access_token,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

async function onlineUser () {
  let ouid = localStorage.getItem('ouid')
  let hausType = localStorage.getItem('ouht')
  let data = {
    id: ouid,
    hausType: hausType
  }
  return data
}

async function hubSend (command, lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    command: command,
    lockId: lockId
  }
  let res = await postdata(API_HUB_SEND, parameters)
  return res.payload
}

export default {
  name: 'lock-card',
  props: ['locationName', 'nextItem'],
  data: () => {
    return {
      modalShow: false,
      onlineUserId: null,
      ouht: null
    }
  },
  mounted () {
    if (!localStorage.getItem('ouid') || !localStorage.getItem('ouht')) {
      onlineUser().then(response => {
        this.$data.onlineUserId = response.id
        this.$data.ouht = response.hausType
      })
    } else {
      this.onlineUserId = localStorage.getItem('ouid')
      this.ouht = localStorage.getItem('ouht')
    }
  },
  methods: {
    details (link, locId) {
      link = link + locId
      location.href = link
    },
    sendKey (lockId) {
      location.href = '/#/base/ekeyform/' + lockId
    },
    listKey (lockId) {
      location.href = '/#/base/ekeylist/' + lockId
    },
    createPasscode (lockId) {
      location.href = '/#/base/passcodeform/' + lockId
    },
    openHistory (lockId) {
      location.href = '/#/base/historyList/' + lockId
    },
    addToLocation (lockId) {
      location.href = '/#/base/locationListAddLock/' + lockId
    },
    addLockToManager (lockId) {
      location.href = '/#/base/managerListForLock/' + lockId
    },
    addToLockGroup (lockId) {
      location.href = '/#/base/lockgroupListAddLock/' + lockId
    },
    listPasscode (lockId) {
      location.href = '/#/base/passcodeList/' + lockId
    },
    detailLock (lockId) {
      location.href = '/#/base/lockDetail/' + lockId
    },
    hubActivate (cmd, lockId) {
      hubSend(cmd, lockId)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    transferLocation (lockId) {
      location.href = '/#/base/locationListAddLock/' + lockId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockCard.vue